import Reflux from 'reflux-react-16'
import moment from 'moment'
import _ from 'underscore'
import socket from '../socketio/socketio.js'
import OrderActions from '../actions/OrderActions.js'
import filter from '../utils/filter.js'
import dbCodes from '../../server/dbCodes.js'
import {calculateRouteRevenue} from '../../utils/routeRevenue.js'
import LoginStore from './LoginStore.js'
import useVehicleStore from './VehicleStore.js'
import {getStoredDates, storeDates} from '../utils/storedDates.js'

export default class OrderStore extends Reflux.Store {
    constructor() {
        super()

        const storedDates = getStoredDates('orders')

        this.state = {
            view: localStorage?.getItem('dashboard-view') || 'routes',
            orderStartDate: storedDates?.startDate || moment().format('YYYY-MM-DD'),
            orderEndDate: storedDates?.endDate || moment().format('YYYY-MM-DD'),
            startTime: '00:00',
            endTime: '24:00',
            startInclude: true,
            endInclude: true,
            orderQueries: [],

            orders: {},
            groupedByRouteId: {},
            filteredOrders: {},
            selectedOrders: [],
            ordersLoading: true,

            routes: {},
            routeTemplates: {},
            activeRouteTab: 'open',
            selectedRouteId: '',
            someRouteHidden: false,

            mapOptions: localStorage.mapOptions ?
                JSON.parse(localStorage.mapOptions) :
                {
                    showRoutePanel: localStorage.showRoutePanel ? localStorage.showRoutePanel === 'true' : true,
                    showOrderPanel: localStorage.showOrderPanel ? localStorage.showOrderPanel === 'true' : true,
                    showOrdersOnMap: localStorage.showOrdersOnMap ? localStorage.showOrdersOnMap === 'true' : true,
                    showCompletedAddressesOnMap: localStorage.showCompletedAddressesOnMap ? localStorage.showCompletedAddressesOnMap === 'true' : false,
                    showRoutesOnMap: localStorage.showRoutesOnMap ? localStorage.showRoutesOnMap === 'true' : true,
                    showStopNumbersOnMap: localStorage.showStopNumbersOnMap ? localStorage.showStopNumbersOnMap === 'true' : true,
                    showDepotsOnMap: true,
                    showExpectedOnMap: localStorage.showExpectedOnMap ? localStorage.showExpectedOnMap === 'true' : true,
                    expandRouteListItems: localStorage.expandRouteListItems ? localStorage.expandRouteListItems === 'true' : true
                },

            showRoutePanel: localStorage.showRoutePanel ? localStorage.showRoutePanel === 'true' : true,
            showOrderPanel: localStorage.showOrderPanel ? localStorage.showOrderPanel === 'true' : true,
            showOrdersOnMap: localStorage.showOrdersOnMap ? localStorage.showOrdersOnMap === 'true' : true,
            showCompletedAddressesOnMap: localStorage.showCompletedAddressesOnMap ? localStorage.showCompletedAddressesOnMap === 'true' : false,
            showRoutesOnMap: localStorage.showRoutesOnMap ? localStorage.showRoutesOnMap === 'true' : true,
            showStopNumbersOnMap: localStorage.showStopNumbersOnMap ? localStorage.showStopNumbersOnMap === 'true' : true,

            orderLimitWarning: false,
            centerViewOnSelected: false,
            simulationUpdateCount: 0,
            lastSimulationUpdateAt: ''
        }

        this.updateOrderIds = []
        this.updateRouteIds = []
        this.updateTimeout = null

        // Last known center/zoom of the planning map, kept in memory only so it survives a remount of the Map
        // but not a page reload. Deliberately not part of this.state: it changes on every pan/zoom and nothing
        // needs to re-render because of it.
        this.mapView = null

        this.listenables = OrderActions

        OrderActions.get(true, true)
        OrderActions.getRouteTemplates()

        socket.on('updateOrders', () => {
            OrderActions.get()
        })

        socket.on('updateOrder', this.updateOrders.bind(this))

        socket.on('updateRouteTemplate', OrderActions.getRouteTemplates)
    }

    updateOrders(orderIds, routeIds, forceUpdate) {
        orderIds = !orderIds ? [] : typeof orderIds === 'string' ? [orderIds] : orderIds
        routeIds = !routeIds ? [] : typeof routeIds === 'string' ? [routeIds] : routeIds

        if (typeof routeIds === 'boolean') {
            forceUpdate = routeIds
            routeIds = []
        }

        console.log(`updateOrders force: ${forceUpdate}`)

        if (forceUpdate) {
            this.processUpdateOrders(orderIds, routeIds)
        } else {
            if (this.updateTimeout) {
                this.updateOrderIds = _.uniq([...this.updateOrderIds, ...orderIds])
                this.updateRouteIds = _.uniq([...this.updateRouteIds, ...routeIds])
            } else {
                this.processUpdateOrders(_.uniq([...this.updateOrderIds, ...orderIds]), _.uniq([...this.updateRouteIds, ...routeIds]))
                this.updateOrderIds = []
                this.updateRouteIds = []

                this.updateTimeout = setTimeout(() => {
                    this.updateTimeout = null

                    if (this.updateOrderIds.length || this.updateRouteIds.length) {
                        this.processUpdateOrders([...this.updateOrderIds], [...this.updateRouteIds])
                        this.updateOrderIds = []
                        this.updateRouteIds = []
                    }
                }, 5000)
            }
        }
    }

    processUpdateOrders(orderIds, routeIds) {
        console.log(`processUpdateOrders orderIds: ${orderIds.length} routeIds: ${routeIds.length}`)

        const {orderStartDate, orderEndDate} = this.state

        socket.emit('orders.get', sessionStorage.token, orderStartDate, orderEndDate, orderIds, routeIds, LoginStore.state.selectedBranchIds, (err, updatedOrders = [], updatedRoutes) => {
            if (err) {
                console.log(err)
                return
            }

            // TODO rename orders to orderObject everywhere?
            const orderObject = {}
            updatedOrders.map((order) => {
                orderObject[order._id] = order
            })
            updatedOrders = orderObject

            // TODO rename routes to routeObject everywhere?
            const routeObject = {}
            updatedRoutes.map((route) => {
                routeObject[route._id] = route
            })
            updatedRoutes = routeObject

            const routes = {...this.state.routes}
            const groupedByRouteId = {...this.state.groupedByRouteId}
            let routesHasChanged = false

            // update routes
            routeIds.map((routeId) => {
                const updatedRoute = updatedRoutes[routeId]

                if (updatedRoute && !updatedRoute.removed) {
                    routes[routeId] = {...routes[routeId], ...updatedRoute}
                    routesHasChanged = true
                } else {
                    if (routes[routeId]) {
                        delete routes[routeId]
                        routesHasChanged = true
                    }
                }
            })

            const {orderQueries, startTime, endTime, startInclude, endInclude} = this.state
            const orders = {...this.state.orders}
            const selectedOrders = [...this.state.selectedOrders]

            let orderHasChanged = false
            const updatedRouteIds = {}

            // update orders
            orderIds.map((id) => {
                const oldOrder = orders[id]
                const order = updatedOrders[id]

                const oldRouteId = oldOrder?.routeId || ''
                const newRouteId = order?.routeId || ''

                if (order && !order.removed) {
                    if (oldRouteId) {
                        if (oldRouteId !== newRouteId) {
                            delete groupedByRouteId[oldRouteId][id]
                        }
                        updatedRouteIds[oldRouteId] = true
                    }

                    if (newRouteId) {
                        if (oldRouteId !== newRouteId) {
                            groupedByRouteId[newRouteId] = groupedByRouteId[newRouteId] || {}
                        }

                        groupedByRouteId[newRouteId][id] = order
                        updatedRouteIds[newRouteId] = true
                    }

                    orders[id] = order
                    orderHasChanged = true
                } else if (oldOrder) {
                    const selectedIndex = selectedOrders.indexOf(id)
                    selectedOrders.splice(selectedIndex, 1)

                    delete orders[id]

                    if (oldRouteId) {
                        delete groupedByRouteId[oldRouteId][id]
                        updatedRouteIds[oldRouteId] = true
                    }

                    orderHasChanged = true
                }
            })

            if (orderHasChanged) {
                // TODO remove duplicate code here and in onGet
                Object.keys(updatedRouteIds).map((routeId) => {
                    if (!routes[routeId]) {
                        return
                    }

                    const route = {...routes[routeId]}

                    route.addresses = []
                    route.colli = []
                    route.reversible = true

                    route.success = 0
                    route.notCompleted = 0
                    route.tooLate = 0

                    // TODO decide wether to do this here or in the orders.js
                    if (route.completedAddresses.length > 0) {
                        route.completedAddresses.map((address, index) => {
                            // Add index to id to prevent duplicate keys. This can happen when an address is completed and then added to the route again and causes problems in sortable lists
                            address.id = `${address.orderId}_${address.index}_${index}  `

                            if (address.success) {
                                route.success += 1
                            } else {
                                route.notCompleted += 1
                            }

                            if (address.timeOfArrival > address.endTime) {
                                route.tooLate += 1
                            }
                        })
                    }

                    Object.values(groupedByRouteId[routeId] || {}).map((order) => {
                        const remainingAddresses = order.addresses.filter((address) => !address.hasArrived)

                        if (remainingAddresses.length > 1 && order.addressOrder !== 'random') {
                            route.reversible = false
                        }

                        // const vehicleType = reseller.settings.vehicleTypes.find((vehicleType) => vehicleType._id === route.vehicleTypeId)

                        // if (vehicleType?.hourlyRate) {
                        //     revenue += parseFloat(vehicleType.hourlyRate.replace(',', '.')) * (route.duration / 3600)
                        // }

                        order.addresses.map((address) => {
                            if (address.hasArrived) {
                                return
                            }

                            if (order.status === dbCodes.status.verwacht()) {
                                address.isExpected = true
                            }

                            route.addresses.push({
                                id: `${order._id}_${address.index}`,
                                orderId: order._id,
                                ...address,
                                ...order.addresses[address.index],
                                senderAddress: order.senderAddress,
                                customerAddress: order.customerAddress
                            })
                        })

                        order.colli.map((collo) => {
                            if (['expected', 'pickup', 'outforpickup', 'athub', 'outfordelivery'].includes(collo.status)) {
                                route.colli.push(collo)
                            }
                        })
                    })

                    // Stops at the same address share a priority, routeSequence keeps the order they were put in. Underscore's
                    // sortBy takes one iteratee and is stable, so sort by routeSequence first
                    route.addresses = _.sortBy(_.sortBy(route.addresses, 'routeSequence'), (address) => {
                        return (!route.started || address.underway) ? address.priority : (999999999 + (address.priority || 0))
                    })

                    Object.assign(route, calculateRouteRevenue(route, Object.values(groupedByRouteId[routeId] || {})))

                    routes[routeId] = route
                })

                const vehicles = useVehicleStore.getState().vehicles

                const filteredOrders = filter.orders(orders, routes, orderQueries, startTime, endTime, startInclude, endInclude, LoginStore.state.reseller, vehicles, LoginStore.state.partners)
                console.log('OrderStore.processUpdateOrders: orderHasChanged')

                this.setState({orders, routes, groupedByRouteId, filteredOrders, selectedOrders})
            } else if (routesHasChanged) {
                for (const route of Object.values(routes)) {
                    Object.assign(route, calculateRouteRevenue(route, Object.values(groupedByRouteId[route._id] || {})))
                }

                console.log('OrderStore.processUpdateOrders: routesHasChanged)')

                this.setState({routes})
            }
        })
    }

    onSetView(view, centerViewOnSelected) {
        const urlParams = new URLSearchParams(window.location.search)

        urlParams.set('view', view === 'routes' ? 'planning' : 'orders')

        window.history.pushState({}, '', `?${urlParams.toString()}`)

        this.setState({centerViewOnSelected})
        setTimeout(() => {
            this.setState({centerViewOnSelected: false})
        }, 1000)
    }

    onSetDates(orderStartDate, orderEndDate) {
        this.setState({orderStartDate, orderEndDate, selectedOrders: [], selectedRouteId: '', focusedRouteId: '', someRouteHidden: false})
        storeDates('orders', orderStartDate, orderEndDate)
        OrderActions.get(true, true)
    }

    onSetTimes(startTime, endTime, startInclude, endInclude) {
        const {orders, routes, orderQueries} = this.state
        const vehicles = useVehicleStore.getState().vehicles

        const filteredOrders = filter.orders(orders, routes, orderQueries, startTime, endTime, startInclude, endInclude, LoginStore.state.reseller, vehicles, LoginStore.state.partners)

        this.setState({filteredOrders, selectedOrders: [], startTime, endTime, startInclude, endInclude})
    }

    onSetQueries(orderQueries) {
        const {orders, routes, startTime, endTime, startInclude, endInclude} = this.state
        const vehicles = useVehicleStore.getState().vehicles

        const filteredOrders = filter.orders(orders, routes, orderQueries, startTime, endTime, startInclude, endInclude, LoginStore.state.reseller, vehicles, LoginStore.state.partners)
        this.setState({filteredOrders, selectedOrders: [], orderQueries})
    }

    onSetSelected(selectedOrders) {
        this.setState({selectedOrders})
    }

    onGet(loading) {
        const {orderStartDate, orderEndDate} = this.state
        this.setState({ordersLoading: !!loading})

        socket.emit('orders.get', sessionStorage.token, orderStartDate, orderEndDate, null, null, LoginStore.state.selectedBranchIds, (err, orders, routes) => {
            if (err) {
                alert(typeof err === 'string' ? err : err instanceof Error ? err.message : err.toString())
                return
            }

            // TODO rename orders to orderObject everywhere?
            const orderObject = {}
            orders.map((order) => {
                orderObject[order._id] = order
            })
            orders = orderObject

            // TODO rename routes to routeObject everywhere?
            const routeObject = {}
            routes.map((route) => {
                routeObject[route._id] = route
            })
            routes = routeObject

            const {selectedOrders, orderQueries, startTime, endTime, startInclude, endInclude} = this.state
            const vehicles = useVehicleStore.getState().vehicles

            const filteredOrders = filter.orders(orders, routes, orderQueries, startTime, endTime, startInclude, endInclude, LoginStore.state.reseller, vehicles, LoginStore.state.partners)

            const groupedByRouteId = {}

            Object.values(orders).map((order) => {
                if (order.routeId) {
                    groupedByRouteId[order.routeId] = groupedByRouteId[order.routeId] || {}
                    groupedByRouteId[order.routeId][order._id] = order
                }
            })

            Object.values(routes).map((route) => {
                route.addresses = []
                route.colli = []
                route.reversible = true

                route.success = 0
                route.notCompleted = 0
                route.tooLate = 0

                // TODO decide wether to do this here or in the orders.js
                if (route.completedAddresses.length > 0) {
                    route.completedAddresses.map((address, index) => {
                        // Add index to id to prevent duplicate keys. This can happen when an address is completed and then added to the route again and causes problems in sortable lists
                        address.id = `${address.orderId}_${address.index}_${index}  `

                        if (address.success) {
                            route.success += 1
                        } else {
                            route.notCompleted += 1
                        }

                        if (address.timeOfArrival > address.endTime) {
                            route.tooLate += 1
                        }
                    })
                }

                Object.values(groupedByRouteId[route._id] || {}).map((order) => {
                    const remainingAddresses = order.addresses.filter((address) => !address.hasArrived)

                    if (remainingAddresses.length > 1 && order.addressOrder !== 'random') {
                        route.reversible = false
                    }

                    order.addresses.map((address) => {
                        if (address.hasArrived) {
                            return
                        }

                        if (order.status === dbCodes.status.verwacht()) {
                            address.isExpected = true
                        }

                        route.addresses.push({
                            id: `${order._id}_${address.index}`,
                            orderId: order._id,
                            ...address,
                            ...order.addresses[address.index],
                            senderAddress: order.senderAddress,
                            customerAddress: order.customerAddress
                        })
                    })

                    order.colli.map((collo) => {
                        if (['expected', 'pickup', 'outforpickup', 'athub', 'outfordelivery'].includes(collo.status)) {
                            route.colli.push(collo)
                        }
                    })
                })

                // Stops at the same address share a priority, routeSequence keeps the order they were put in. Underscore's
                // sortBy takes one iteratee and is stable, so sort by routeSequence first
                route.addresses = _.sortBy(_.sortBy(route.addresses, 'routeSequence'), (address) => {
                    return (!route.started || address.underway) ? address.priority : (999999999 + (address.priority || 0))
                })

                Object.assign(route, calculateRouteRevenue(route, Object.values(groupedByRouteId[route._id] || {})))
            })

            this.setState({
                orders,
                routes,
                groupedByRouteId,
                filteredOrders,
                selectedOrders: selectedOrders.filter((id) => !!filteredOrders[id]),
                ordersLoading: false,
                orderLimitWarning: Object.keys(orders).length >= 35000
            })
        })
    }

    onGetOne(id, callback) {
        socket.emit('orders.getOne', sessionStorage.token, id, callback)
    }

    onGetRecentCustomerOrders(customerId, nrOfOrders, skipNrOfOrders, callback) {
        socket.emit('orders.getRecentCustomerOrders', sessionStorage.token, customerId, nrOfOrders, skipNrOfOrders, callback)
    }

    onCreate(...args) {
        socket.emit('orders.create', sessionStorage.token, ...args)
    }

    onEdit(...args) {
        socket.emit('orders.edit', sessionStorage.token, ...args)
    }

    onGetTemplate(...args) {
        socket.emit('orders.getTemplate', sessionStorage.token, ...args)
    }

    onGetTemplates(query, callback) {
        socket.emit('orders.getTemplates', sessionStorage.token, query, LoginStore.state.selectedBranchIds, callback)
    }

    onEditTemplate(...args) {
        socket.emit('orders.editTemplate', sessionStorage.token, ...args)
    }

    onEditInfo(...args) {
        socket.emit('orders.editInfo', sessionStorage.token, ...args)
    }

    onEditDate(...args) {
        socket.emit('orders.editDate', sessionStorage.token, ...args)
    }

    onEditAddress(...args) {
        socket.emit('orders.editAddress', sessionStorage.token, ...args)
    }

    onEditCollo(...args) {
        socket.emit('orders.editCollo', sessionStorage.token, ...args)
    }

    onEditAdministration(...args) {
        socket.emit('orders.editAdministration', sessionStorage.token, ...args)
    }

    onEditMoreOptions(...args) {
        socket.emit('orders.editMoreOptions', sessionStorage.token, ...args)
    }

    onAtHub(...args) {
        socket.emit('orders.atHub', sessionStorage.token, ...args)
    }

    onReschedule(...args) {
        socket.emit('orders.reschedule', sessionStorage.token, ...args)
    }

    onSendToPartner(...args) {
        socket.emit('orders.sendToPartner', sessionStorage.token, ...args)
    }

    onOnHold(...args) {
        socket.emit('orders.onHold', sessionStorage.token, ...args)
    }

    onNotSupplied(...args) {
        socket.emit('orders.notSupplied', sessionStorage.token, ...args)
    }

    onManco(...args) {
        socket.emit('orders.manco', sessionStorage.token, ...args)
    }

    onComplete(...args) {
        socket.emit('orders.complete', sessionStorage.token, ...args)
    }

    onPickup(...args) {
        socket.emit('orders.pickup', sessionStorage.token, ...args)
    }

    onDeliver(...args) {
        socket.emit('orders.deliver', sessionStorage.token, ...args)
    }

    onGetNotPossibleReasons(...args) {
        socket.emit('orders.getNotPossibleReasons', sessionStorage.token, ...args)
    }

    onAddOptions(...args) {
        socket.emit('orders.addOptions', sessionStorage.token, ...args)
    }

    onEditBranch(...args) {
        socket.emit('orders.editBranch', sessionStorage.token, ...args)
    }

    onRemove(id, callback) {
        socket.emit('orders.remove', sessionStorage.token, id, callback)
    }

    onRecalculateDeliveryZoneIds(ids, callback) {
        socket.emit('orders.recalculateDeliveryZoneIds', sessionStorage.token, ids, callback)
    }

    onRemoveTemplate(...args) {
        socket.emit('orders.removeTemplate', sessionStorage.token, ...args)
    }

    onPrintLabels(ids, nrOfEmptyLabels, adressIndex, colloIndex, callback) {
        const printerPageSize = localStorage.printerPageSize || 'A6'
        socket.emit('orders.printLabels', sessionStorage.token, ids, printerPageSize, nrOfEmptyLabels, adressIndex, colloIndex, callback)
    }

    onGetPrice(order, callback) {
        socket.emit('orders.getPrice', sessionStorage.token, order, callback)
    }

    onAddHistoryComment(...args) {
        socket.emit('orders.addHistoryComment', sessionStorage.token, ...args)
    }

    onSendRetour(...args) {
        socket.emit('orders.sendRetour', sessionStorage.token, ...args)
    }

    onCancelRetour(...args) {
        socket.emit('orders.cancelRetour', sessionStorage.token, ...args)
    }

    onNewRoute(...args) {
        socket.emit('orders.newRoute', sessionStorage.token, ...args)
    }

    onUpdateRoute(routeId, update, callback) {
        const routes = {...this.state.routes}
        const oldRoute = structuredClone(routes[routeId])

        routes[routeId] = {...routes[routeId], ...update, loading: true}

        this.setState({routes})

        socket.emit('orders.updateRoute', sessionStorage.token, routeId, update, (err) => {
            const routes = {...this.state.routes}

            routes[routeId] = {...routes[routeId], loading: false}

            if (err) {
                routes[routeId] = oldRoute
            }

            this.setState({routes, error: err})

            typeof callback === 'function' && callback(err)
        })
    }

    onRescheduleRoute(routeId, date, callback) {
        const routes = {...this.state.routes}
        const oldRoute = structuredClone(routes[routeId])

        routes[routeId] = {...routes[routeId], loading: true}

        this.setState({routes})

        socket.emit('orders.rescheduleRoute', sessionStorage.token, routeId, date, (err, errors) => {
            const routes = {...this.state.routes}

            routes[routeId] = {...routes[routeId], loading: false}

            if (err) {
                routes[routeId] = oldRoute
            }

            this.setState({routes, error: err})

            typeof callback === 'function' && callback(err, errors)
        })
    }

    onRemoveRoute(...args) {
        socket.emit('orders.removeRoute', sessionStorage.token, ...args)
    }

    onAddToRoute(...args) {
        socket.emit('orders.addToRoute', sessionStorage.token, ...args)
    }

    onCreatePlanning(ids, options, callback) {
        const {orderStartDate} = this.state
        options.date = orderStartDate
        socket.emit('orders.createPlanning', sessionStorage.token, ids, options, callback)
    }

    onPlanRoute(routeId, optimize, reverse, changedAddresses, callback) {
        const routes = {...this.state.routes}
        const oldRoute = structuredClone(routes[routeId])

        routes[routeId] = {...routes[routeId], loading: true}

        if (changedAddresses) {
            // Completed addresses are included in changedAddresses because they are rendered in the same list, so we need to filter them out
            changedAddresses = changedAddresses.filter((address) => !address.hasArrived)
            routes[routeId] = {...routes[routeId], addresses: changedAddresses}
        }

        this.setState({routes})

        socket.emit('orders.planRoute', sessionStorage.token, {routeId, optimize, reverse, changedAddresses}, (err) => {
            const routes = {...this.state.routes}

            routes[routeId] = {...routes[routeId], loading: false}

            if (err) {
                routes[routeId] = oldRoute
            }

            this.setState({routes, error: err})

            typeof callback === 'function' && callback(err)
        })
    }

    onStopRoute(routeId, callback) {
        const routes = {...this.state.routes}
        const oldRoute = structuredClone(routes[routeId])

        routes[routeId] = {...routes[routeId], loading: true}

        this.setState({routes})

        socket.emit('orders.stopRoute', sessionStorage.token, routeId, (err, errors) => {
            const routes = {...this.state.routes}

            routes[routeId] = {...routes[routeId], loading: false}

            if (err) {
                routes[routeId] = oldRoute
            }

            this.setState({routes, error: err})

            typeof callback === 'function' && callback(err, errors)
        })
    }

    onSetRouteReady(routeId, ready, callback) {
        const routes = {...this.state.routes}
        const oldRoute = structuredClone(routes[routeId])

        routes[routeId] = {...routes[routeId], loading: true}

        this.setState({routes})

        socket.emit('orders.setRouteReady', sessionStorage.token, routeId, ready, (err, errors) => {
            const routes = {...this.state.routes}

            routes[routeId] = {...routes[routeId], loading: false}

            if (err) {
                routes[routeId] = oldRoute
            }

            this.setState({routes, error: err})

            typeof callback === 'function' && callback(err, errors)
        })
    }

    onSetRouteLocked(routeId, locked, callback) {
        const routes = {...this.state.routes}

        routes[routeId] = {...routes[routeId], loading: true}

        this.setState({routes})

        socket.emit('orders.setRouteLocked', sessionStorage.token, routeId, locked, (err) => {
            const routes = {...this.state.routes}

            routes[routeId] = {...routes[routeId], loading: false}

            this.setState({routes, error: err})

            typeof callback === 'function' && callback(err)
        })
    }

    onSetAddressLocked(...args) {
        socket.emit('orders.setAddressLocked', sessionStorage.token, ...args)
    }

    onSetRouteAnchoring(routeId, enabled, callback) {
        const routes = {...this.state.routes}

        routes[routeId] = {...routes[routeId], loading: true}

        this.setState({routes})

        socket.emit('orders.setRouteAnchoring', sessionStorage.token, routeId, enabled, (err) => {
            const routes = {...this.state.routes}

            routes[routeId] = {...routes[routeId], loading: false}

            this.setState({routes, error: err})

            typeof callback === 'function' && callback(err)
        })
    }

    onResetRoutesHidden() {
        const routes = {...this.state.routes}

        Object.keys(routes).map((routeId) => {
            if (routes[routeId].hidden) {
                routes[routeId] = {...routes[routeId], hidden: false}
            }
        })

        this.setState({routes, focusedRouteId: '', someRouteHidden: false})
    }

    onSetRouteHidden(routeId, hidden) {
        const routes = {...this.state.routes}
        routes[routeId] = {...routes[routeId], hidden: typeof hidden === 'boolean' ? hidden : !routes[routeId].hidden}

        const someRouteHidden = _.some(Object.values(routes), (route) => route.hidden)

        this.setState({routes, focusedRouteId: '', someRouteHidden})
    }

    onSetRouteLoading(routeId, loading) {
        // Don't bring back a route that was removed in the meantime
        if (!this.state.routes[routeId]) {
            return
        }

        const routes = {...this.state.routes}
        routes[routeId] = {...routes[routeId], loading}

        this.setState({routes})
    }

    onSetRouteFocus(routeId) {
        const routes = {...this.state.routes}

        if (routeId === this.state.focusedRouteId) {
            routeId = ''
        }

        if (routeId) {
            routes[routeId] = {...routes[routeId], hidden: false}
        }

        const someRouteHidden = _.some(Object.values(routes), (route) => route.hidden)

        this.setState({routes, focusedRouteId: routeId, someRouteHidden})
    }

    onSetActiveRouteTab(activeRouteTab) {
        this.setState({activeRouteTab, selectedRouteId: ''})
    }

    onSetSelectedRoute(selectedRouteId) {
        this.setState({selectedRouteId})
    }

    onGetRouteTemplate(routeTemplateId, callback) {
        socket.emit('orders.getRouteTemplate', sessionStorage.token, routeTemplateId, (err, routeTemplate) => {
            callback(err, routeTemplate)

            if (routeTemplate) {
                const routeTemplates = this.state.routeTemplates
                routeTemplates[routeTemplate._id] = routeTemplate

                this.setState({routeTemplates})
            }
        })
    }

    onGetRouteTemplates() {
        socket.emit('orders.getRouteTemplates', sessionStorage.token, LoginStore.state.selectedBranchIds, (routeTemplates) => {
            this.setState({routeTemplates})
        })
    }

    onCreateRouteTemplate(...args) {
        socket.emit('orders.createRouteTemplate', sessionStorage.token, ...args)
    }

    onUpdateRouteTemplate(...args) {
        socket.emit('orders.updateRouteTemplate', sessionStorage.token, ...args)
    }

    onRemoveRouteTemplates(...args) {
        socket.emit('orders.removeRouteTemplates', sessionStorage.token, ...args)
    }

    onChangeTimeslot(...args) {
        socket.emit('orders.changeTimeslot', sessionStorage.token, ...args)
    }

    onCheck(...args) {
        socket.emit('orders.check', sessionStorage.token, ...args)
    }

    onSendDeliveryMail(...args) {
        socket.emit('orders.sendDeliveryMail', sessionStorage.token, ...args)
    }

    onFindByBarcode(...args) {
        socket.emit('orders.findByBarcode', sessionStorage.token, ...args)
    }

    onScan(...args) {
        socket.emit('orders.scan', sessionStorage.token, ...args)
    }

    onSetMapOptions(update) {
        const {mapOptions} = this.state

        this.setState({mapOptions: {...mapOptions, ...update}})
        localStorage.mapOptions = JSON.stringify({...mapOptions, ...update})
    }

    onSetMapView(update) {
        this.mapView = {...this.mapView, ...update}
    }

    onSetShowRoutePanel() {
        const {showRoutePanel} = this.state
        this.setState({showRoutePanel: !showRoutePanel})
        localStorage.showRoutePanel = this.state.showRoutePanel ? 'true' : 'false'
    }

    onSetShowOrderPanel() {
        const {showOrderPanel} = this.state
        this.setState({showOrderPanel: !showOrderPanel})
        localStorage.showOrderPanel = this.state.showOrderPanel ? 'true' : 'false'
    }

    onSetShowOrdersOnMap() {
        const {showOrdersOnMap} = this.state
        this.setState({showOrdersOnMap: !showOrdersOnMap})
        localStorage.showOrdersOnMap = this.state.showOrdersOnMap ? 'true' : 'false'
    }

    onSetShowRoutesOnMap() {
        const {showRoutesOnMap} = this.state
        this.setState({showRoutesOnMap: !showRoutesOnMap})
        localStorage.showRoutesOnMap = this.state.showRoutesOnMap ? 'true' : 'false'
    }

    onSetShowCompletedAddresses() {
        const {showCompletedAddressesOnMap} = this.state
        this.setState({showCompletedAddressesOnMap: !showCompletedAddressesOnMap})
        localStorage.showCompletedAddressesOnMap = this.state.showCompletedAddressesOnMap ? 'true' : 'false'
    }

    onSetShowStopNumbersOnMap() {
        const {showStopNumbersOnMap} = this.state
        this.setState({showStopNumbersOnMap: !showStopNumbersOnMap})
        localStorage.showStopNumbersOnMap = this.state.showStopNumbersOnMap ? 'true' : 'false'
    }

    onClearError() {
        this.setState({error: ''})
    }

    onGetFile(...args) {
        socket.emit('orders.getFile', sessionStorage.token, ...args)
    }
}
